module.exports = __webpack_public_path__ + "static/per-marker-customisation-80eb8331c4933fcb3a3cd9ac4a6cfe17.png";